export default __webpack_public_path__ + "static/media/placeholder-firstServe-cover.dd96d54b.svg";